// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__308Br","consentsList":"PatientConsents_consentsList__2L3A3","consentsListEmpty":"PatientConsents_consentsListEmpty__3SYqY"};